import { IInitialState } from "us.collection.admin/reducers/CreditorGroup/Interfaces";
// IMPORTANT: Import directly from the local file to avoid circular dependency via the State index barrel.
// Using the barrel (../State) caused InitialState to execute while the CreditorGroup constant was still in the temporal dead zone,
// leading to "Cannot access 'k' before initialization" after minification.
import { CreditorGroup } from "./CreditorGroup";

export const initialState: IInitialState = {
  creditorGroups: {
    data: [],
    isFetching: false,
  },
  creditorGroupDetails: {
    data: CreditorGroup,
    isFetching: false,
  },
  drawer: {
    title: "",
    visible: false,
    isNewCreditorGroup: true,
  },
  selectedCreditors: {
    data: [],
    isFetching: false
  }
};
